import {
    AuthRoute,
    ChannelFeatures,
    ConsultationFeatures,
    DietFeatures,
    EnrolmentFeatures,
    LeadFeatures,
    NavBarRoute,
    PrescriptionFeatures,
    SessionFeatures,
    TagsFeatures,
    UserPermissionModules,
    UserRole,
    UsersFeatures
} from "./users.models";


export const nullRole: UserRole = {
    routes: new Set([]),
    default_route: AuthRoute.insufficient_access,
    module_permissions: {}
}

export const careUserRole: UserRole = {
    routes: new Set([
        NavBarRoute.care_dashboard,
        NavBarRoute.care_tasks,
        NavBarRoute.care_chat,
        NavBarRoute.care_patients,
        NavBarRoute.care_renewals,
    ]),
    default_route: NavBarRoute.care_tasks,
    module_permissions: {
        [UserPermissionModules.enrolment]: {
            features: new Set<string>([
                EnrolmentFeatures.change_instructions_to_chat_team,
                EnrolmentFeatures.view_dietitian_consultation_task,
                EnrolmentFeatures.view_dietitian_check_in_task,
            ])
        },
        [UserPermissionModules.channel]: {
            features: new Set<string>([
                ChannelFeatures.send_quick_replies,
            ])
        }
    },
}

export const careChatUserRole: UserRole = {
    routes: new Set([
        NavBarRoute.care_chat,
    ]),
    default_route: NavBarRoute.care_chat,
    module_permissions: {
        [UserPermissionModules.enrolment]: {
            features: new Set<string>([
                EnrolmentFeatures.send_community_link,
                EnrolmentFeatures.view_conversation_starters,
                EnrolmentFeatures.change_chat_team_notes
            ])
        },
        [UserPermissionModules.channel]: {
            features: new Set<string>([
                ChannelFeatures.send_quick_replies,
            ])
        }
    }
}

export const fitnessInstructorRole: UserRole = {
    routes: new Set([
        NavBarRoute.sessions_batches,
        NavBarRoute.sessions_patients,
        NavBarRoute.sessions_tasks,
        NavBarRoute.sessions_patient_transfer,
    ]),
    default_route: NavBarRoute.sessions_batches,
    module_permissions: {
        [UserPermissionModules.enrolment]: {
            features: new Set<string>([
                EnrolmentFeatures.change_instructions_to_chat_team,
                EnrolmentFeatures.change_fitness_instructor_notes,
                EnrolmentFeatures.view_fitness_instructor_consultation_task
            ])
        }
    },
}


export const specialInstructorRole: UserRole = {
    routes: new Set([
        NavBarRoute.care_chat,
        NavBarRoute.care_patients,
        NavBarRoute.sessions_special_consultation_tasks,
        NavBarRoute.sessions_webinars,
    ]),
    default_route: NavBarRoute.sessions_special_consultation_tasks,
    module_permissions: {
        [UserPermissionModules.enrolment]: {
            features: new Set<string>([
                EnrolmentFeatures.change_instructions_to_chat_team,
                EnrolmentFeatures.change_fitness_instructor_notes,
                EnrolmentFeatures.view_special_consultation_task
            ])
        }
    },
}


export const salesUserRole: UserRole = {
    routes: new Set([
        NavBarRoute.sales_tasks,
        NavBarRoute.sales_patients,
        NavBarRoute.sales_chat,
        NavBarRoute.sales_whatsapp_chat
    ]),
    default_route: NavBarRoute.sales_tasks,
    module_permissions: {}
}

export const salesChatUserRole: UserRole = {
    routes: new Set([
        NavBarRoute.sales_patients,
        NavBarRoute.sales_chat,
    ]),
    default_route: NavBarRoute.sales_chat,
    module_permissions: {
        [UserPermissionModules.lead]: {
            features: new Set<string>([
                LeadFeatures.view_all,
                LeadFeatures.view_restricted_fields,
                LeadFeatures.change_phone_number
            ])
        },
        [UserPermissionModules.enrolment]: {
            features: new Set<string>([])
        },
        [UserPermissionModules.channel]: {
            features: new Set<string>([
                ChannelFeatures.send_quick_replies,
            ])
        }
    }
}

export const careAdminRole: UserRole = {
    routes: new Set([
        NavBarRoute.care_patient_assignment,
        NavBarRoute.care_query_assignment,
        NavBarRoute.care_diet_chart_template_management,
        NavBarRoute.care_whatsapp_chat,
        NavBarRoute.care_refer_patients,
    ]),
    default_route: NavBarRoute.care_patients,
    module_permissions: {
        [UserPermissionModules.users]: {
            features: new Set<string>([
                UsersFeatures.change_phone_number
            ])
        },
        [UserPermissionModules.enrolment]: {
            features: new Set<string>([
                EnrolmentFeatures.view_all,
                EnrolmentFeatures.change_owner,
                EnrolmentFeatures.change_duration,
                EnrolmentFeatures.send_community_link,
                EnrolmentFeatures.view_conversation_starters,
                EnrolmentFeatures.view_trial_onboarding_task,
                EnrolmentFeatures.create_complementary_special_consultation_task,
                EnrolmentFeatures.change_phone_number,
            ])
        },
        [UserPermissionModules.consultation]: {
            features: new Set<string>([
                ConsultationFeatures.change_owner,
                ConsultationFeatures.create_custom_event,
                ConsultationFeatures.change_type
            ])
        },
        [UserPermissionModules.diet]: {
            features: new Set<string>([
                DietFeatures.view_all,
                DietFeatures.edit_all,
                DietFeatures.approve
            ])
        }
    },
    inherits_from: [
        careUserRole,
        careChatUserRole,
    ]
}


export const careSeniorAdminRole: UserRole = {
    routes: new Set([]),
    default_route: NavBarRoute.care_patients,
    module_permissions: {
        [UserPermissionModules.enrolment]: {
            features: new Set<string>([
                EnrolmentFeatures.discount_prospect,
            ])
        },
    },
    inherits_from: [
        careAdminRole,
    ]
}

export const careQARole: UserRole = {
    routes: new Set([
        NavBarRoute.care_diet_chart_template_management,
        NavBarRoute.care_whatsapp_chat,
    ]),
    default_route: NavBarRoute.care_patients,
    module_permissions: {
        [UserPermissionModules.users]: {
            features: new Set<string>([
                UsersFeatures.change_phone_number
            ])
        },
        [UserPermissionModules.enrolment]: {
            features: new Set<string>([
                EnrolmentFeatures.view_all,
                EnrolmentFeatures.change_owner,
                EnrolmentFeatures.change_duration,
                EnrolmentFeatures.send_community_link,
                EnrolmentFeatures.view_conversation_starters
            ])
        },
        [UserPermissionModules.consultation]: {
            features: new Set<string>([
                ConsultationFeatures.change_owner,
                ConsultationFeatures.create_custom_event,
                ConsultationFeatures.change_type
            ])
        },
        [UserPermissionModules.diet]: {
            features: new Set<string>([
                DietFeatures.view_all,
                DietFeatures.edit_all,
                DietFeatures.approve
            ])
        }
    },
    inherits_from: [
        careUserRole,
        careChatUserRole,
    ]
}

export const sessionAdminUserRole: UserRole = {
    routes: new Set([

        NavBarRoute.sessions_calendar,
        NavBarRoute.sessions_standalone,
        NavBarRoute.sessions_course,
        NavBarRoute.sessions_recurring,
    ]),
    default_route: NavBarRoute.sessions_batches,
    module_permissions: {
        [UserPermissionModules.enrolment]: {
            features: new Set<string>([
                EnrolmentFeatures.change_instructions_to_chat_team,
                EnrolmentFeatures.change_fitness_instructor_notes,
                EnrolmentFeatures.send_community_link,
                EnrolmentFeatures.opt_in_to_restricted_batch,
            ])
        },
        [UserPermissionModules.session]: {
            features: new Set([
                SessionFeatures.edit_all,
            ])
        }
    },
    inherits_from: [
        fitnessInstructorRole
    ]
}

export const productUserRole: UserRole = {
    routes: new Set([
        NavBarRoute.care_chat,
        NavBarRoute.care_patients,
        NavBarRoute.care_whatsapp_chat,
        NavBarRoute.sessions_calendar,
        NavBarRoute.sessions_standalone,
        NavBarRoute.sessions_course,
        NavBarRoute.sessions_recurring,
        NavBarRoute.tools_edit_message_template,
        NavBarRoute.tools_send_message_template,
        NavBarRoute.tools_upload_assets,
        NavBarRoute.tools_knowledge_base,
        NavBarRoute.tools_whatsapp_login,
        NavBarRoute.tools_query_review
    ]),
    default_route: NavBarRoute.care_patients,
    module_permissions: {
        [UserPermissionModules.enrolment]: {
            features: new Set<string>([
                EnrolmentFeatures.view_all,
                EnrolmentFeatures.send_community_link,
                EnrolmentFeatures.opt_in_to_restricted_batch,
                EnrolmentFeatures.view_dietitian_consultation_task,
                EnrolmentFeatures.view_dietitian_check_in_task,
                EnrolmentFeatures.view_fitness_instructor_consultation_task,
                EnrolmentFeatures.view_special_consultation_task,
                EnrolmentFeatures.view_trial_onboarding_task
            ])
        },
        [UserPermissionModules.channel]: {
            features: new Set([
                ChannelFeatures.view_all_queries,
                ChannelFeatures.send_quick_replies
            ])
        },
        [UserPermissionModules.session]: {
            features: new Set([
                SessionFeatures.view_all,
                SessionFeatures.edit_all,
            ])
        }
    },
    inherits_from: [
        sessionAdminUserRole,
        fitnessInstructorRole,
        specialInstructorRole
    ]
}

export const salesAdminRole: UserRole = {
    routes: new Set([
        NavBarRoute.tools_whatsapp_login,
        NavBarRoute.doctors_profile,
    ]),
    default_route: NavBarRoute.sales_patients,
    module_permissions: {
        [UserPermissionModules.lead]: {
            features: new Set<string>([
                LeadFeatures.view_all,
                LeadFeatures.change_owner,
                LeadFeatures.view_restricted_fields,
                LeadFeatures.discounted_bill,
                LeadFeatures.change_phone_number,
                LeadFeatures.add_qa_comments
            ])
        },
        [UserPermissionModules.tags]: {
            features: new Set<string>([
                TagsFeatures.create,
            ])
        }

    },
    inherits_from: [
        salesUserRole,
        salesChatUserRole
    ]
}

export const careSuperAdminRole: UserRole = {
    routes: new Set([]),
    default_route: NavBarRoute.care_patients,
    module_permissions: {},
    inherits_from: [
        careSeniorAdminRole,
        salesAdminRole,
    ]
}

export const bdAdminRole: UserRole = {
    routes: new Set([
        NavBarRoute.doctors_prescribe_patient,
        NavBarRoute.doctors_feedbacks,
        NavBarRoute.doctors_profile,
        NavBarRoute.doctors_send_notification
    ]),
    default_route: NavBarRoute.doctors_prescribe_patient,
    module_permissions: {}
}

export const superAdminRole: UserRole = {
    routes: new Set(),
    module_permissions: {
        [UserPermissionModules.enrolment]: {
            features: new Set([
                EnrolmentFeatures.change_phone_number,
                EnrolmentFeatures.view_memory
            ])
        },
        [UserPermissionModules.prescription]: {
            features: new Set([
                PrescriptionFeatures.skip_validation
            ])
        },
        [UserPermissionModules.channel]: {
            features: new Set([
                ChannelFeatures.override_query_validation,
                ChannelFeatures.view_all_queries
            ])
        }
    },
    default_route: NavBarRoute.care_patients,
    inherits_from: [
        careSuperAdminRole,
        bdAdminRole,
        productUserRole
    ]
}

export const userToUserRoleMapping: { [id: string]: UserRole } = {
    '0cac4ff0-30a5-4b7e-a673-43944519cf5b': careSuperAdminRole, //Riya
    '1ec2fe3d-6452-4a10-8661-0513c74039a2': careSeniorAdminRole, //Kriti
    'ebc1b43f-e971-40bc-a1ef-71185060bfea': careAdminRole, //Raksha
    '66958c4e-763b-4ae6-a04b-5148a99131a9': careAdminRole, //Twinkle,
    'fbfe7a82-486e-4c46-b0ae-a2bbdda85800': careQARole, // Piyali
    '857b71e8-40e7-4d1c-bf8b-96052ab2ed67': salesChatUserRole, //Zishan
    '918f2b59-9b0b-4a3f-9c6d-393aa45ccf71': nullRole, //Chat Team
    '88b6c686-dea0-4712-aef2-53fd93018cdf': superAdminRole, //Tech
    '0d30b7e2-a477-45e6-8d49-7529001fdcfa': productUserRole, //Anushak
    '055f196f-d8aa-4a53-9436-f52cea5b8e9d': salesAdminRole, //Query Admin/John
    'd2601e8a-4726-444e-82ea-64d4a90615f8': careChatUserRole, //Pregnancy Chat Team
    '2f125b02-6378-4b9a-8b57-dd5bfd4e5283': careChatUserRole, //Non Preg Chat Team
    '56a30548-972f-4bd2-91b8-e0b10854bc4a': superAdminRole, //John
    'de3aa531-53c1-4c00-94db-44dcdff1e446': salesAdminRole, //Arpit
    'cd0814e1-ffe7-4888-b664-e5c376ef593f': bdAdminRole, //Shaurya Sarswat
    '4836036c-81dd-4185-9cea-299867dea3e8': specialInstructorRole, //Dr. Maneesha Mohan
    'de21b1b1-3538-4a3d-8ba2-15f8b928c0d1': specialInstructorRole, //Mansi Joshi
    '5a78fbbb-1a36-43ef-b075-e35a6b04365d': specialInstructorRole, //Dr. Alpa
    '97c4e032-f6e2-4da1-bdbd-87a7c4524ca1': sessionAdminUserRole, //Rekha Ranawat
}
